import { FormBuilder, FormGroup } from '@angular/forms';

/**
 * Crea un FormGroup de documento vacio con la misma forma que
 * `FormularioDocumentoService.montarFormularioDocVacio`, sin validadores.
 *
 * Se extrae como factory pura para poder construir un `formularioDocumento`
 * independiente por documento en el flujo Envio simple sin depender del
 * estado interno (ni de las dependencias pesadas) de `FormularioDocumentoService`.
 */
export function buildFormularioDocumentoVacio(fb: FormBuilder): FormGroup {
  return fb.group({
    idTipoDocumento: [null],
    nombre: [''],
    urlDocTemp: [''],
    idPdf: [''],
    idTipoDocOrigen: [null],
    copyConfiguracion: [false],
    generico: [],
    incluirContenido: [false],
    tiposContenido: fb.array([]),
    texto: [''],
    textoFormulario: [''],
    textoAExcluir: [''],
    textoAExcluirFormulario: [''],
    contieneCif: [false],
    posicionCif: [],
    cifOrden: [],
    cifPage: [],
    cifFormulario: [],
    cif: [''],
    cifResueltoPage: [null],
    cifResueltoOrden: [null],
    firmantesNif: fb.array([]),
    paginas: [],
    esCopiaBasica: [],
    split: [''],
    formatoNombreArchivoAuditTrail: [''],
    formatoNombreArchivoFirmado: [''],
    esRLT: [false]
  });
}
